import React from 'react';

import CurrentPageContext from 'CurrentPageContext';
import { USER_COMMENTS_FOR_ADMISSION } from 'resources/common/constants';
import {
  PAGE_LINKS,
  ADMISSIONS_META_DATA,
  ADMISSIONS_PAGE_TYPE,
  ADMISSIONS_PAGE_DISPLAY_NAME,
} from 'components/Admissions/admissionConstants';

import { AdmissionPageProps } from 'components/Admissions/admissionTypes';
import Admissions from 'components/Admissions/Admissions';
import { fetchAdmissionPageData, getAdmissionsRelatedPost } from 'components/Admissions/admissionsApi';
import { NextPageContext } from 'next';
import { getMetaTags } from 'utils/cms';
import { metaDataMap } from 'components/Admissions/admissionConstants/metaData';

/**
 * Admission pages have URL structure as [group]/[page]
 * Groups can be sop, lor, etc
 * page can be overview, samples, format etc
 */
class ContentPages extends React.Component<AdmissionPageProps> {
  static async getInitialProps(ctx: NextPageContext) {
    const { group} = this.getURLParams(ctx);
    if (!group) {
      ctx.res?.end();
    }

    const pageLinks = PAGE_LINKS[group] || [];

    const pageType = ADMISSIONS_PAGE_TYPE[group];
    const pageDisplayName = ADMISSIONS_PAGE_DISPLAY_NAME[group];
    // various api paths for the current page
    const groupData = ADMISSIONS_META_DATA[group];
    const pageData = groupData['overview'];

    if (!pageData || !pageType) {
      ctx.res?.end();
    }
    const metaData = metaDataMap[group];
    const pageMeta = pageData.meta;
    const metaVariables = {
      documentName: pageData.groupName,
      groupAbbreviation: pageData.groupAbbreviation,
      pageName: pageData.pageName
    };
    const metaTags = await getMetaTags(ctx.asPath as string, metaVariables);
    const {relatedPosts:relatedBlogs} = await getAdmissionsRelatedPost(pageType);
    const [pageResponseJSON, authorResponseJSON, documentsAPIResponseJSON ] =
      await fetchAdmissionPageData(group, 'overview');
    return {
      author: authorResponseJSON,
      blog: pageResponseJSON,
      documentsList: documentsAPIResponseJSON,
      pageHeading: pageData.pageHeading,
      pageSections: pageLinks,
      pageType,
      pageDisplayName,
      pageMeta,
      metaTags,
      url: {
        pathname: ctx.pathname,
        query: ctx.query,
        asPath: ctx.asPath,
      },
      relatedBlogs,
      metaData
    };
  }

  static getURLParams = (router: NextPageContext): Record<string, string> => {
    let { group} = router.query;
    group = (group as string).replace(/-/g, '');
    return { group};
  };

  render() {
    return (
      <CurrentPageContext.Provider value={USER_COMMENTS_FOR_ADMISSION}>
        <Admissions {...this.props}  />
      </CurrentPageContext.Provider>
    );
  }
}

export default ContentPages;
